import React, { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import axios from 'axios';
// import Turnstile from 'react-turnstile';
import './Auth.css';

const Signup = () => {
    const [formData, setFormData] = useState({
        firstName: '',
        lastName: '',
        email: '',
        password: '',
        confirmPassword: ''
    });
    const [error, setError] = useState('');
    // const [captchaToken, setCaptchaToken] = useState(null);
    // const [captchaLoaded, setCaptchaLoaded] = useState(false);
    const navigate = useNavigate();
    
    // Force development mode to bypass CAPTCHA
    // const isDevelopment = true;
    
    // Comment out CAPTCHA related code
    // const SITE_KEY = process.env.REACT_APP_CLOUDFLARE_SITE_KEY || "0x4AAAAAABAMwgSnbk3flmdF";

    const handleChange = (e) => {
        setFormData({
            ...formData,
            [e.target.name]: e.target.value
        });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setError('');

        // Validate password match
        if (formData.password !== formData.confirmPassword) {
            setError('Passwords do not match');
            return;
        }

        // Comment out CAPTCHA verification
        // if (!isDevelopment && !captchaToken) {
        //     setError('Please complete the CAPTCHA verification');
        //     return;
        // }

        try {
            await axios.post('/api/signup', {
                ...formData,
                // captchaToken,
                isDevelopment: true // Always send development flag to bypass server CAPTCHA check
            });

            // Redirect to login with success message
            navigate('/login', { 
                state: { message: 'Account created successfully! Please log in.' } 
            });
        } catch (err) {
            setError(err.response?.data?.error || 'Signup failed. Please try again.');
            
            // Comment out CAPTCHA reset
            // if (!isDevelopment && window.turnstile) {
            //     window.turnstile.reset();
            //     setCaptchaToken(null);
            // }
        }
    };

    return (
        <div className="auth-container">
            <div className="auth-card">
                <h2>Create an Account</h2>
                {error && <div className="error-message">{error}</div>}
                <form onSubmit={handleSubmit}>
                    <div className="form-group">
                        <label htmlFor="firstName">First Name</label>
                        <input
                            type="text"
                            id="firstName"
                            name="firstName"
                            value={formData.firstName}
                            onChange={handleChange}
                            required
                        />
                    </div>
                    <div className="form-group">
                        <label htmlFor="lastName">Last Name</label>
                        <input
                            type="text"
                            id="lastName"
                            name="lastName"
                            value={formData.lastName}
                            onChange={handleChange}
                            required
                        />
                    </div>
                    <div className="form-group">
                        <label htmlFor="email">Email</label>
                        <input
                            type="email"
                            id="email"
                            name="email"
                            value={formData.email}
                            onChange={handleChange}
                            required
                        />
                    </div>
                    <div className="form-group">
                        <label htmlFor="password">Password</label>
                        <input
                            type="password"
                            id="password"
                            name="password"
                            value={formData.password}
                            onChange={handleChange}
                            required
                            minLength="8"
                        />
                    </div>
                    <div className="form-group">
                        <label htmlFor="confirmPassword">Confirm Password</label>
                        <input
                            type="password"
                            id="confirmPassword"
                            name="confirmPassword"
                            value={formData.confirmPassword}
                            onChange={handleChange}
                            required
                        />
                    </div>
                    
                    {/* CAPTCHA component commented out */}
                    {/* <div className="form-group captcha-container">
                        <Turnstile
                            sitekey={SITE_KEY}
                            onVerify={(token) => setCaptchaToken(token)}
                            onLoad={() => setCaptchaLoaded(true)}
                            onError={() => {
                                console.error('Turnstile error');
                                setError('CAPTCHA verification failed to load. Please refresh the page.');
                            }}
                            refreshExpired="auto"
                        />
                        {!captchaLoaded && <div className="captcha-loading">Loading CAPTCHA verification...</div>}
                    </div> */}
                    
                    <button type="submit" className="auth-button">Sign Up</button>
                </form>
                <p className="auth-link">
                    Already have an account? <Link to="/login">Login</Link>
                </p>
            </div>
        </div>
    );
};

export default Signup;